import { BaseSelectionManager } from './shared/BaseSelectionManager.js';

export default function objectFurnitureData() {
  const isPresent = document.querySelector('.select-furniture-button');
  if (!isPresent) {
    return;
  }

  const manager = new BaseSelectionManager({
    type: 'furniture',
    buttonSelector: '.select-furniture-button',
    itemSelector: '.single-furniture-item',
    containerSelector: '[data-list-item-selected-furniture]', 
    clearButtonSelector: '[data-clear-choices-furniture]',
    confirmButtonSelector: '[data-confirm-furniture]',
    changeButtonSelector: '[data-change-furniture]',
    frontButtonSelector: '[data-front-select-furniture]',
    priceAttribute: 'data-furniture-item-price',
    confirmationClass: 'furniture-confirmed',
    dataAttributes: {
      clearCatAttribute: 'data-furniture-cat-in-list',
      clearCatTitleAttribute: 'data-furniture-cat-in-list-title'
    },
    messages: {
      userDisabled: 'Muudatuste tegemine pole lubatud',
      selected: 'Valitud',
      select: 'Vali', 
      confirmed: 'Päring saadetud',
      confirm: 'Saada mööbli päring',
      frontSelect: 'Mööblipäringut tegema'
    }
  });

  // Furniture-specific functionality
  setupFurnitureViewHandlers();
  
  return manager;
}

function setupFurnitureViewHandlers() {
  // Activate the first furniture item
  function activateFirstFurnitureItem() {
    const firstItem = document.querySelector(
      '[data-furniture-selection-wrapper] [data-trigger-details]'
    );
    if (firstItem) {
      firstItem.click();
    }
  }

  // Add event listeners for furniture view triggers
  const furnitureTriggers = document.querySelectorAll(
    '[data-view-trigger="furniture"]'
  );

  if (furnitureTriggers.length > 0) {
    furnitureTriggers.forEach(trigger => {
      trigger.addEventListener('click', activateFirstFurnitureItem);
    });
  }

  // Check URL parameters on page load
  function checkUrlForFurniture() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'furniture') {
      setTimeout(activateFirstFurnitureItem, 300);
    }
  }

  // Run URL check when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkUrlForFurniture);
  } else {
    checkUrlForFurniture();
  }
}